import React from 'react';
import strings from 'localization/strings';
import { skipLinkId, skipLinkTargetId } from 'helpers/SkipLinkHelper';
import { makeStyles } from 'styles/util';

const SkipLink = () => {
	const useStyles = makeStyles(() => ({
		skipLink: {
			border: 0,
			clipPath: 'inset(50%)',
			height: '1px,',
			margin: '-1px',
			overflow: 'hidden',
			padding: '0',
			position: 'absolute',
			width: '1px',
			wordWrap: 'normal !important',
			'&:focus': {
				backgroundColor: '#eee',
				clipPath: 'none',
				color: '#444',
				display: 'block',
				fontSize: '1em',
				height: 'auto',
				left: '5px',
				lineHeight: 'normal',
				padding: '15px 23px 14px',
				textDecoration: 'none',
				top: '5px',
				width: 'auto',
				zIndex: 100000
			}
		}
	}));

	const classes = useStyles();

    return (
		<a className={classes.skipLink} id={skipLinkId} href={`#${skipLinkTargetId}`}>{strings.skipLinkText}</a>
    );
};

export default SkipLink;
